export const UPDATE_TIME = 1000;
export const VK_COLOR = '#07F';
